module.exports = __webpack_public_path__ + "static/media/spirited_away-loc.ee07db14.JPG";